<!-- *ngIf="campaignService.showCallDetails" -->
@if(false){
<ng-container>
  <div class="modal__overlay"></div>
  <div cdkDrag class="caller-module-wrapper">
    <div class="caller-module">
      <div class="caller-module__title">
        <span>{{campaignService.callType}} Call</span>
      </div>
      <div class="caller-module__info">
        <i class="fa-thin fa-user-hair"></i>
        <span>
          {{campaignService.lead?.CustomerInfo?.FirstName ?? '--'}} {{campaignService.lead?.CustomerInfo?.LastName ??
          '--'}}
        </span>
        <p>{{campaignService.btn}}</p>
      </div>
      @if(!telephonyState.onReservationReceived){
      <div class="caller-module__card">
        <div class="attention"><span>Disposition</span>
          <p>
            {{campaignService.lead?.LastCallDisposition?.Name ?? '-----'}}
          </p>
        </div>
        <div><span>Talk Time</span>
          <p>
            {{campaignService.lead?.LastCallMinutes ?? '--:--:--'}}
          </p>
        </div>
        <div><span>Skill</span>
          <p>
            {{campaignService.lead?.LastCallCampaign?.Code ?? '--'}}
          </p>
        </div>
      </div>
      }
      <!-- *ngIf="campaignService.primaryCampaign?.AutoAcceptCall" -->

      @if(!campaignService.primaryCampaign?.AutoAcceptCall && telephonyState.onReservationReceived){
      <div class="caller-module__action-btns">
        <button class="single-button-calling single-button-calling--hang-up" (click)="rejectCall()">
          <i class="fa-solid fa-phone-hangup" [ngClass]="{'disabled' : loading }"></i>
        </button>
        <button class="single-button-calling single-button-calling--attend" (click)="acceptCall()">
          <i class="attend fa-solid fa-phone" [ngClass]="{'disabled' : loading }"></i>
        </button>
      </div>
      }
    </div>
  </div>
</ng-container>
}

@if(campaignService.showCallDetails){
<!-- <div class="caller-module-container" style="
    z-index: 50;
">
  <div class="banner-wrapper">
    <div class="caller-module-horizental">

      <div class="user-avatar"> <i class="fa-thin fa-user-hair"></i></div>

      <div class="caller-module__info">
        <h2 class="caller-module__title">Inbound call</h2>
        <h3>Usama Ayoub</h3>
        <p>03337588013</p>
      </div>



      <div class="button-container">
        <div class="ring-wrapper">

          <div class="pulse-ring"></div>


          <button class="call-button" title="Accept Call">
            <i class="fa-thin fa-phone"></i>
          </button>
        </div>
      </div>

    </div>
  </div>

</div> -->




<!-- horizental call banner -->
<div class="inbound-call-notification">
  <div class="inbound-content">
    <button class="decline-button" title="Dismiss" (click)="campaignService.removeNotification()">
      <i class="fa-solid fa-xmark"></i>
    </button>

    <div class="inbound-content-main">
      <!-- Avatar Section -->
    <div class="avatar-container">
      <div class="avatar">
        <i class="fa-light fa-user fa-2x"></i>
      </div>
      <div class="avatar-pulse"></div>
    </div>

    <!-- Content Section -->
    <div class="info">
      <p class="incoming-title">{{campaignService.callType}} call</p>
      <h2 class="name">  {{campaignService.lead?.CustomerInfo?.FirstName ?? '---'}} {{campaignService.lead?.CustomerInfo?.LastName ?? '---'}} </h2>
      <p class="phone">{{campaignService.btn}}  </p>
    </div>

    <!-- Buttons Section -->
    <div class="notification-action-container">
      <div class="ring-wrapper">
        <!-- Pulsing Ring -->
        <div class="pulse-ring"></div>

        <button class="call-button" title="Accept Call">
          <i class="fa-light fa-phone"></i>
        </button>
      </div>
    </div>
    </div>

    
 <div class="inbound-content-footer">
            <div class="stat-item">
              <span class="stat-label">Disposition</span>
              <div class="disposition-badge">{{campaignService.lead?.LastCallDisposition?.Name ?? '-----'}}</div>
            </div>
            <div class="stat-item">
              <span class="stat-label">Talk Time</span>
              <div class="talk-time-value">{{campaignService.lead?.LastCallMinutes ?? '--:--:--'}}</div>
            </div>
            <div class="stat-item">
              <span class="stat-label">Skill</span>
              <div class="interaction-value">{{campaignService.lead?.LastCallCampaign?.Code ?? '---'}}</div>
            </div>
          </div>
    

    
   
  </div>
</div>

}